import { render, staticRenderFns } from "./WorkMachineExpirationStep.vue?vue&type=template&id=4b5a67d7"
import script from "./WorkMachineExpirationStep.vue?vue&type=script&lang=js"
export * from "./WorkMachineExpirationStep.vue?vue&type=script&lang=js"
import style0 from "./WorkMachineExpirationStep.vue?vue&type=style&index=0&id=4b5a67d7&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports